import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-value-added-service',
    templateUrl: './value-added-service.component.html',
    styleUrls: ['./value-added-service.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ValueAddedServiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
